import Input from "app/components/Input";
import TextArea from "app/components/TextArea";
import DropdownNameSelect from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/DropdownNameSelect";
import DateSelection from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/DateSelection";
import TeamMemberSelection from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/TeamMemberSelection";
import LabelSelection from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/LabelSelection";
import URLInput from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/URLInput";
import { CustomFieldType } from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/types";
import { TicketField } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";

import React from "react";

type CustomFieldValue = string | number | boolean | Date | string[];

export const fieldRenderers = (
  field: TicketField,
  getValue: (id: string) => CustomFieldValue | "",
  getError: (id: string) => string,
  onChange: (id: string, value: CustomFieldValue, shouldSave?: boolean) => void,
  isFirst: boolean,
  isLast: boolean,
) => ({
  [CustomFieldType.TEXT]: (f: TicketField) => (
    <Input
      placeholder="-"
      id={`task-${f._id}`}
      inputClassName="!h-[42px] w-full rounded-l-[0px] border-0"
      name={f._id}
      value={getValue(f._id) as string}
      onChange={(e) => {
        onChange(f._id, e.target.value);
      }}
      onBlur={(e) => {
        onChange(f._id, e.target.value, true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onChange(f._id, e.currentTarget.value, true);
          e.currentTarget.blur();
        }
      }}
      error={getError(f._id)}
    />
  ),

  [CustomFieldType.LONG_TEXT]: (f: TicketField) => (
    <TextArea
      placeholder="-"
      id={`task-${f._id}`}
      value={getValue(f._id) as string}
      onChange={(e) => {
        onChange(f._id, e.target.value);
      }}
      onBlur={(e) => {
        onChange(f._id, e.target.value, true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          onChange(f._id, e.currentTarget.value, true);
          e.currentTarget.blur();
        }
      }}
      textAreaClassName=" w-full resize-none h-full max-h-[90px] overflow-auto rounded-l-[0px] border-0 "
      minRow={3}
      className="w-full border-0 resize-none"
    />
  ),

  [CustomFieldType.DROPDOWN]: (f: TicketField) => (
    <DropdownNameSelect
      value={getValue(f._id) as string}
      options={f.dropDownOptions}
      error={getError(f._id)}
      onChange={(val) => {
        onChange(f._id, val, true);
      }}
    />
  ),

  [CustomFieldType.DATE]: (f: TicketField) => (
    <DateSelection
      value={getValue(f._id) as string}
      error={getError(f._id)}
      onChange={(val) => {
        onChange(f._id, val, true);
      }}
      placeholder={`Enter ${f.fieldToolTip.toLowerCase()}`}
    />
  ),

  [CustomFieldType.NUMBER]: (f: TicketField) => (
    <Input
      placeholder="-"
      id={`task-${f._id}`}
      value={getValue(f._id) as string}
      onChange={(e) => {
        onChange(f._id, e.target.value);
      }}
      onBlur={(e) => {
        onChange(f._id, e.target.value, true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onChange(f._id, e.currentTarget.value, true);
          e.currentTarget.blur();
        }
      }}
      type="number"
      inputClassName="!h-[42px] w-full rounded-l-[0px] border-0"
    />
  ),

  [CustomFieldType.TEAM_MEMBER_SINGLE_SELECT]: (f: TicketField) => (
    <TeamMemberSelection
      value={getValue(f._id) as string}
      onSelect={(val) => {
        onChange(f._id, val, true);
      }}
      error={getError(f._id)}
      placeholder={`Enter ${f.fieldToolTip.toLowerCase()}`}
      isMultiSelect={false}
    />
  ),

  [CustomFieldType.TEAM_MEMBER_MULTI_SELECT]: (f: TicketField) => (
    <TeamMemberSelection
      value={getValue(f._id) as string[]}
      onSelect={(val) => {
        onChange(f._id, val, true);
      }}
      error={getError(f._id)}
      placeholder={`Enter ${f.fieldToolTip.toLowerCase()}`}
      isMultiSelect
    />
  ),

  [CustomFieldType.LABEL]: (f: TicketField) => (
    <LabelSelection
      value={getValue(f._id) as string | string[]}
      onChange={(val) => {
        onChange(f._id, val, true);
      }}
      error={getError(f._id)}
      options={f?.labels ?? []}
    />
  ),

  [CustomFieldType.URL]: (f: TicketField) => (
    <URLInput
      onChange={(val) => {
        onChange(f._id, val);
      }}
      onBlurCommit={(val) => {
        onChange(f._id, val, true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onChange(
            f._id,
            (e.currentTarget as HTMLInputElement).value,
            true,
          );
          (e.currentTarget as HTMLInputElement).blur();
        }
      }}
      value={getValue(f._id) as string}
      placeholder="-"
      error={getError(f._id)}
      inputClassName="!h-[42px] w-full rounded-l-[0px] border-0"
    />
  ),
});
